import _throttle from 'lodash/throttle';
import { useEffect, useMemo, useRef } from 'react';

import Analytics from '@web-solutions/module-analytics';

export const useSummaryViewedRate = (usersPercentToActivateScrollMetric: string | undefined, isSummaryReady: boolean) => {
  const maxViewedPercent = useRef(0);
  const randomNumber = useMemo(() => Math.floor(Math.random() * 100) + 1, []);

  useEffect(() => {
    if (isSummaryReady && usersPercentToActivateScrollMetric && randomNumber <= parseInt(usersPercentToActivateScrollMetric)) {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const visiblePercent = Math.round((windowHeight / documentHeight) * 100);
      const roundedVisiblePercent = Math.round(visiblePercent / 5) * 5;
      maxViewedPercent.current = roundedVisiblePercent;
      Analytics.setUserProperty('summaryViewedRate', `${roundedVisiblePercent}%`);
    }
  }, [isSummaryReady, usersPercentToActivateScrollMetric, randomNumber]);

  useEffect(() => {
    if (usersPercentToActivateScrollMetric && randomNumber <= parseInt(usersPercentToActivateScrollMetric)) {
      const handleScroll = _throttle(() => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrolled = document.documentElement.scrollTop;
        const viewedArea = windowHeight + scrolled;
        const viewedPercent = (viewedArea / documentHeight) * 100;
        const roundedMaxViewedPercent = Math.round(viewedPercent / 5) * 5;

        if (roundedMaxViewedPercent > maxViewedPercent.current) {
          maxViewedPercent.current = roundedMaxViewedPercent;
          Analytics.setUserProperty('summaryViewedRate', `${roundedMaxViewedPercent}%`);
        }
      }, 500);

      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [usersPercentToActivateScrollMetric, randomNumber]);
}

